// extracted by mini-css-extract-plugin
export default {"alert":"QqkGv7uRICXSnuLCIg0P"};